import { createFileRoute, Navigate } from '@tanstack/react-router'
import { Page } from '~/components'
import { WorkflowTable } from '~/features/workflows/components/WorkflowTable'
import { useFeature } from '~/hooks'
import { WorkflowRun } from '~/features/workflows/components/WorkflowRun'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/workflows')({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId, botId } = Route.useParams()
  const enabled = useFeature('workflow-page')

  if (!enabled) {
    return <Navigate to="/workspaces/$workspaceId/bots/$botId" params={{ workspaceId, botId }} />
  }

  return (
    <Page title="Workflows - *** ENG ONLY ***">
      <WorkflowRun botId={botId} workspaceId={workspaceId} />
      <WorkflowTable botId={botId} workspaceId={workspaceId} />
    </Page>
  )
}
